import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {requireImage} from '../../utils/utils';
import {getRootStore} from '../../app.bootstrap';

import './styles.scss';

interface TsModalImageProps {
    imageSrc: string;
    imageTitle?: string;
    imageText?: string;
    imageNote?: string;
}

interface ModalImageData {
    src: string;
    title: string;
    text: string;
    note: string;
}

const ModalImagePopup: React.FC<{
    data: ModalImageData;
    onClose: () => void;
}> = ({data, onClose}) => {
    return (
        <div className='ts-modal-image-popup-overlay' onClick={onClose}>
            <div className='modal-dialog' onClick={(e) => e.stopPropagation()}>
                <div className='modal-content'>
                    <div className='ts-modal-image-header'>
                        <button type='button' className='ts-modal-image-popup-close pull-right' onClick={onClose}>
                            &times;
                        </button>
                    </div>
                    <img className='ts-modal-image-popup-img' src={data.src} alt={data.title} />
                    {data.note && <div className='ts-modal-image-popup-note'>{data.note}</div>}
                    {data.text && <div className='ts-modal-image-popup-text'>{data.text}</div>}
                </div>
            </div>
        </div>
    );
};

export class TsModalImage extends TechseeBaseComponent<TsModalImageProps> {
    state = {
        isModalOpen: false
    };

    private translate = getRootStore().localizationService.translate;

    private handleImageClick = (): void => {
        this.setState({isModalOpen: true});
    };

    private handleCloseModal = (): void => {
        this.setState({isModalOpen: false});
    };

    private getImageData = (): ModalImageData => {
        const {imageSrc, imageTitle, imageText, imageNote} = this.props;
        // Add safety check for imageSrc
        if (!imageSrc) {
            return {
                src: '',
                title: imageTitle ? this.translate(imageTitle) : '',
                text: imageText ? this.translate(imageText) : '',
                note: imageNote ? this.translate(imageNote) : ''
            };
        }

        return {
            src: requireImage(imageSrc),
            title: imageTitle ? this.translate(imageTitle) : '',
            text: imageText ? this.translate(imageText) : '',
            note: imageNote ? this.translate(imageNote) : ''
        };
    };

    renderInternal(): JSX.Element {
        const {isModalOpen} = this.state;
        const imageData = this.getImageData();
        return (
            <>
                <div className='ts-modal-image-container'>
                    <img
                        src={imageData.src}
                        onClick={this.handleImageClick}
                        className='ts-modal-image'
                        alt={imageData.text || (this.props.imageText ? this.translate(this.props.imageText) : '')}
                    />
                    {imageData.title && <div className='ts-modal-image-title'>{imageData.title}</div>}
                </div>

                {isModalOpen && <ModalImagePopup data={imageData} onClose={this.handleCloseModal} />}
            </>
        );
    }
}
